module.exports = __webpack_public_path__ + "static/thumbnails/screenshot--homes.png";